import React, { ReactElement } from 'react';
import { TooltipProps } from '@fiverr-private/tooltip';
import { logger, stats } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/ui_utils';

const LazyTooltip = (props: TooltipProps) => {
  const lazyImport = () => import(/* webpackChunkName: 'BadgeTooltipV1' */ '../BadgeTooltip');

  const onLoadError = (error: any) => {
    stats.count(`libs.penta.lazy_load.failure`, `badge_tooltip`);
    logger.warn(error, {
      description: 'Failed to lazy-load Tooltip component',
    });
  };

  return (
    <LazyComponent<TooltipProps>
      lazyImport={lazyImport}
      shouldImport={true}
      componentProps={props}
      onError={onLoadError}
      placeholder={props.children as ReactElement}
      fallback={props.children as ReactElement}
    />
  );
};

LazyTooltip.displayName = 'LazyTooltip';

export default LazyTooltip;
